import React from "react";
import { FormProvider } from "react-hook-form";
import { Create } from "@refinedev/mui";

import { UserForm } from "@modules/users/components/UserForm";
import { useUserCreateForm } from "./controller";

export const UserCreate = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending } = useUserCreateForm();

  return (
    <Create
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
    >
      <FormProvider {...methods}>
        <UserForm />
      </FormProvider>
    </Create>
  );
});
